import controller from './alert-box.controller';

const template = require('./alert-box.html');

export default {
    bindings: {
        alerts: '<',
        selectedThingId: '<'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/alert-box/alert-box.component.js